export default __webpack_public_path__ + "static/media/ic-search.65a7fd14.svg";